import React from 'react';
import CheckList from 'commonComponents/CheckList/CheckList';
import BaseSectionWithImage from 'commonComponents/sections/BaseSectionWithImage/BaseSectionWithImage';
import { StrategiesPhoto, strategiesCardImages } from '../images';
import styles from './Strategies.module.scss';

const Strategies = ({ content, horisontalCards }) => {
  return (
    <BaseSectionWithImage
      { ...content }
      image={ StrategiesPhoto }
      anchor='strategies'
    >
      <HorizontalCards { ...horisontalCards } />
    </BaseSectionWithImage>
  );
};

const HorizontalCards = ({ list }) => {
  list.map((item, index) => (
    item.image = strategiesCardImages[index]
  ));

  return (
    <div className={ styles.HorizontalCards }>
      { list.map((item, index) => (
        <HorizontalCard key={ index } { ...item } />
      )) }
    </div>
  );
};

const HorizontalCard = ({ title, text, features, image }) => {
  return (
    <div className={ styles.HorizontalCard }>
      <figure><img src={ image } /></figure>
      <article>
        <h3>{ title }</h3>
        <p>{ text }</p>
        <CheckList list={ features } />
      </article>
    </div>
  );
};

export default Strategies;
